export const qrcodeQueryKeys = {
  // Common
  fetchQrCodeById: 'fetchQrCodeById',
  fetchQrCodeStyles: 'fetchQrCodeStyles',
  // Static - URL
  createStaticQrUrl: 'createStaticQrUrl',
  updateStaticQrUrl: 'updateStaticQrUrl',
  deleteStaticQrUrl: 'deleteStaticQrUrl',
  // Static - TEXT
  createStaticQrText: 'createStaticQrText',
  updateStaticQrText: 'updateStaticQrText',
  deleteStaticQrText: 'deleteStaticQrText',
  // Static - WIFI
  createStaticQrWifi: 'createStaticQrWifi',
  updateStaticQrWifi: 'updateStaticQrWifi',
  deleteStaticQrWifi: 'deleteStaticQrWifi',
  // Static - EMAIL
  createStaticQrEmail: 'createStaticQrEmail',
  updateStaticQrEmail: 'updateStaticQrEmail',
  deleteStaticQrEmail: 'deleteStaticQrEmail',
  // Static - SMS
  createStaticQrSms: 'createStaticQrSms',
  updateStaticQrSms: 'updateStaticQrSms',
  deleteStaticQrSms: 'deleteStaticQrSms',
  // Static - WhatsApp
  createStaticQrWhatsApp: 'createStaticQrWhatsApp',
  updateStaticQrWhatsApp: 'updateStaticQrWhatsApp',
  deleteStaticQrWhatsApp: 'deleteStaticQrWhatsApp',
  // Static - VCard
  createStaticQrVCard: 'createStaticQrVCard',
  updateStaticQrVCard: 'updateStaticQrVCard',
  deleteStaticQrVCard: 'deleteStaticQrVCard',
};
